import * as React from "react";

import { Grid, makeStyles, Typography } from "@material-ui/core";
import { Rating } from "@mui/lab";
import Empty from "../../../static/Empty";
import { rateText } from "../../../static/rateText";

const useStyles = makeStyles((theme) => ({
  starsContainer: {
    padding: 10,
    margin: "auto",
    marginTop: "10px",
    marginBottom: 20,

    [theme.breakpoints.down("md")]: {
      marginTop: 0,
    },
  },
  singleStar: {
    margin: "10px 0px",

    "& p": {
      fontSize: "1.818rem !important",
      fontFamily: "Vazir-Medium",
      color: "rgba(33, 33, 33, 0.87)",
    },
    "& .MuiRating-root span": {
      fontSize: "3rem",
    },
    [theme.breakpoints.down("md")]: {
      margin: "auto",
    },
  },
  opener: {
    cursor: "pointer",
    color: "#009693",
    fontSize: "20px",
    textAlign: "center",
    marginTop: "10px",
    fontWeight: "bold",
    paddingBottom: "50px",
  },
  rate: {
    marginTop: 5,
  },
  t1: {
    padding: 5,
    display: "inline-block",
  },
}));

const UserRate = ({ rate, ...props }) => {
  const classes = useStyles();

  const rateKeys = Object.keys(rate) || [];

  if (rate && rateKeys && rateKeys.length > 0) {
    return (
      <>
        <Grid
          item
          container
          xs={12}
          sm={12}
          md={12}
          justifyContent="space-between"
          alignItems="center"
          className={classes.starsContainer}
        >
          {rateKeys.map((item) => (
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              className={classes.singleStar}
              key={item}
              container
              justifyContent="space-between"
              alignItems="center"
            >
              <Rating
                readOnly
                size="large"
                defaultValue={rate[item]}
                className={classes.rate}
              />
              <Typography variant="h5" className={classes.t1}>
                {rateText[item]}{" "}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </>
    );
  }
  return <Empty text="اطلاعات یافت نشد." />;
};

export default UserRate;
